import { api, ApiError } from './api';
import { avisar, pedirTexto, textoDeError } from '../components/Dialogo';

/**
 * Confirmar con el PIN (0.47.0). Lo delicado (hoy: cuentas de prueba y reiniciar el PIN de otra persona) pide el PIN de
 * quien lo hace, con el diálogo de la app (nada nativo). El servidor lo revisa en la cabecera `X-Hub-Pin` y contesta
 * `pin: 'incorrecto' | 'bloqueado' | 'sin_pin' | 'falta'`; aquí se vuelve a pedir con el error en rojo (incorrecto),
 * se dice hasta cuándo (bloqueado) o se manda a "Mi cuenta" (sin PIN). Devuelve lo que contestó la acción, o null si se
 * canceló o no se pudo (el aviso ya se enseñó).
 *
 *   const r = await conPin('Marcar como cuenta de prueba', (pin) => api(`pruebas/${id}`, { method: 'PUT', headers: { 'X-Hub-Pin': pin }, body }));
 */
export async function conPin<T>(accion: string, hacer: (pin: string) => Promise<T>, opts: { irAMiCuenta?: () => void; errorTitulo?: string } = {}): Promise<T | null> {
  let error: string | undefined;
  for (let intento = 0; intento < 6; intento++) {
    const pin = await pedirTexto({ titulo: 'Confirma con tu PIN', mensaje: `${accion}.`, etiqueta: 'Tu PIN de DTB HUB', pin: true, requerido: true, confirmar: 'Confirmar', error });
    if (pin === null) return null;
    try {
      return await hacer(pin);
    } catch (e) {
      const cod = e instanceof ApiError ? e.body?.pin : undefined;
      if (cod === 'incorrecto' || cod === 'formato') { error = textoDeError(e); continue; }
      if (cod === 'sin_pin') {
        await avisar({ titulo: 'Todavía no tienes PIN', mensaje: `${textoDeError(e)}\nEs de 4 a 6 números y sólo tú lo sabes.`, tipo: 'info', boton: 'Ir a Mi cuenta' });
        opts.irAMiCuenta?.();
        return null;
      }
      if (cod === 'bloqueado') { await avisar({ titulo: 'PIN bloqueado', mensaje: textoDeError(e), tipo: 'error' }); return null; }
      await avisar({ titulo: opts.errorTitulo || 'No se pudo', mensaje: textoDeError(e), tipo: 'error' });
      return null;
    }
  }
  return null;
}

/** La cabecera del PIN para `api(…, { headers: pinHeader(pin) })`. */
export const pinHeader = (pin: string) => ({ 'X-Hub-Pin': pin });

export interface EstadoPin { tiene: boolean; bloqueadoHasta: string | null; intentos: number; actualizado: string | null; ultimoUso: string | null }
export const leerMiPin = () => api<EstadoPin>('cuenta/pin');
